import { Dispatch } from 'redux'

import {
  GET_COUNTRIES,
  ADD_COUNTRY,
  DELETE_COUNTRY,
  SEARCH_COUNTRY,
  Country,
  CountryActions,
} from '../../types'

export function getCountries(data: Country[]): CountryActions {
  return {
    type: GET_COUNTRIES,
    payload: {
      countries: data,
    },
  }
}

export function addNewCountry(country: Country): CountryActions {
  return {
    type: ADD_COUNTRY,
    payload: {
      country,
    },
  }
}

export function deleteCountry(country: Country): CountryActions {
  return {
    type: DELETE_COUNTRY,
    payload: {
      country,
    },
  }
}

export function searchCountry(country: Country[]): CountryActions {
  return {
    type: SEARCH_COUNTRY,
    payload: {
      country: country,
    },
  }
}

export function fetchCountries() {
  const url = 'https://restcountries.com/v3.1/all'
  return async (dispatch: Dispatch) => {
    const res = await fetch(url)
    const countries = await res.json()
    dispatch(getCountries(countries))
  }
}
